import React, { useContext, useEffect, useState, useMemo, useCallback } from "react";
import { Container, Row } from "reactstrap";
import NavBar from "../../components/NavBar";
import CreateCourseCard from "../../components/courses/sections/CreateCourseCard";
import FeedAdvertisement from "../../components/feeds/sidebar/FeedAdvertisement";
import SuggestedCoursesEvents from "../../components/feeds/sidebar/SuggestedCoursesEvents";
import CourseBanner from "../../components/courses/sections/CourseBanner";
import banner_1 from "../../assets/images/icons/course_banner_1.jpg";
import banner_2 from "../../assets/images/icons/course_banner_2.jpg";
import banner_3 from "../../assets/images/icons/course_banner_3.jpg";
import CoursesTabMenuCard from "../../components/courses/sections/CoursesTabMenuCard";
import { fetchAllCoursesTypeData, fetchCoursesData, getSeeCoursesByType } from "../../services/coursesApi";
import { toast } from "react-toastify";
import TrendingCourses from "../../components/courses/sections/TrendingCourses";
import SubcategoryCards from "../../components/courses/sections/SubcategoryCards";
import FollowingDoctorCourses from "../../components/courses/sections/FollowingDoctorCourses";
import RecommendedCourses from "../../components/courses/sections/RecommendedCourses";
import PurchasedCourses from "../../components/courses/sections/PurchasedCourses";
import SavedCourses from "../../components/courses/sections/SavedCourses";
import MyCourses from "../../components/courses/sections/MyCourses";
import { useInfiniteQuery, useQuery } from "react-query";
import SeeAllCoursesCard from "../../components/courses/See-All-Components/SeeAllCoursesCard";
import { COURSES, EVENTS } from "../../constants/RoutesUrl";
import { useLocation, useNavigate } from "react-router-dom";
import { Language } from "../../App";
import CourseSearchBox from "./CourseSearchBox";
import CreateCourseModal from "../../components/courses/modals/CreateCourseModal";
import { FaSearch, FaPlus } from "react-icons/fa";
import { useCheckSubscriptionPermission } from "../../hooks/useCheckSubscriptionPermission";
import MixpanelManager from "../../constants/MixpanelManager";
import { MixpanelEvents } from "../../constants/MixpanelEvents";
import "./Courses.css";

const banner_images = [banner_1, banner_2, banner_3];

const Courses = () => {
  const { lang } = useContext(Language);
  const navigate = useNavigate();
  const location = useLocation();
  const [adsLoading, setAdsLoading] = useState(true);
  const storedValue = useMemo(() => JSON.parse(localStorage.getItem("contest_obj")), []);
  const [isOpen, setIsOpen] = useState(false);
  const checkPermission = useCheckSubscriptionPermission("upload_course");
  const user = useMemo(() => JSON.parse(localStorage.getItem("SplashData")), []);

  useEffect(() => {
    if (user?.user) {
      MixpanelManager.identify(
        user.user.id,
        user.user.email,
        user.user.name,
        user.user.profile_image
      );
    }
    MixpanelManager.track(MixpanelEvents.appCourses, { page: "courses_main" });
  }, [user?.user]);

  const toggle = () => {
    if (!checkPermission()) return;
    if (!isOpen) {
      MixpanelManager.track(MixpanelEvents.createCourse);
    }
    setIsOpen(!isOpen);
  };

  const handleSearchClick = () => {
    MixpanelManager.track(MixpanelEvents.searchCourse);
    navigate("/courses/filter");
  };

  const [selectedCourseType, setSelectedCourseType] = useState(
    location.state?.selectedCourseType || null
  );
  const [coursesHeading, setCoursesHeading] = useState(
    location.state?.selectedCategoryName || null
  );
  const [categoryId, setCategoryId] = useState(
    location.state?.selectedCategoryId || null
  );
  const [internalLoading, setInternalLoading] = useState(false);
  const [counts, setCounts] = useState({
    purchased: 0,
    saved: 0,
    created: 0,
  });

  const translatedCourseTypes = useMemo(
    () => [
      { id: 1, title: lang.purchased_courses || lang.purchased || "Purchased", key: "purchased" },
      { id: 2, title: lang.saved_courses || lang.saved || "Saved", key: "saved" },
      { id: 3, title: lang.my_courses || "My Courses", key: "created" },
    ],
    [lang]
  );

  const viewAllPurchased = useCallback(
    (courseType, pageType, type) => {
      const isSamePage = pageType === location.pathname;

      if (isSamePage) {
        const routeMap = {
          courses: `${COURSES}/1`,
          events: `${EVENTS}/1`,
        };

        const selectedTypeKey =
          type === "courses" ? "selectedCourseType" : "selectedEventType";

        if (routeMap[type]) {
          MixpanelManager.track(MixpanelEvents.purchasedCourses, { view: "see_all" });
          navigate(routeMap[type], { state: { [selectedTypeKey]: courseType } });
          setSelectedCourseType(courseType);
        }

        window.scrollTo(0, 0);
      }
    },
    [navigate, location.pathname]
  );

  const handleCategoryData = useCallback((data, name, loading, id) => {
    setCategoryId(id);
    setCoursesHeading(name);
    if (id) {
      setInternalLoading(true);
      MixpanelManager.track(MixpanelEvents.coursesByCategory, {
        category: name,
        category_id: id,
      });
    }
  }, []);

  const { data, isLoading } = useQuery({
    queryKey: ["coursesData"],
    queryFn: fetchCoursesData,
    onMutate: () => {
      setAdsLoading(true);
    },
    onSuccess: (data) => {
      setCounts({
        purchased: data?.home?.purchased_count || 0,
        saved: data?.home?.saved_count || 0,
        created: data?.home?.user_created_count || 0,
      });
    },
    onSettled: () => {
      setAdsLoading(false);
    },
    refetchOnWindowFocus: false,
  });

  const {
    data: categoryData,
    isLoading: isCategoryLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: ["categoryCourses", categoryId],
    queryFn: ({ pageParam = 1 }) =>
      fetchAllCoursesTypeData({ category_id: categoryId, page: pageParam, limit: 12 }),
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage?.data?.current_page + 1;
      return nextPage <= lastPage?.data?.last_page ? nextPage : undefined;
    },
    enabled: !!categoryId,
    refetchOnWindowFocus: false,
    onError: (error) => {
      toast.error(error.message);
    },
    onSettled: () => {
      setInternalLoading(false);
    },
  });

  const categoryCourses = useMemo(
    () => categoryData?.pages?.flatMap((page) => page.data.data) || [],
    [categoryData]
  );

  const handleCourseTypeClick = useCallback(
    (id) => {
      setSelectedCourseType((prev) => (prev === id ? null : id));
      const courseTypeMap = { 1: "purchased", 2: "saved", 3: "my_courses" };
      MixpanelManager.track(MixpanelEvents.selectedPostType, { type: courseTypeMap[id] });
    },
    []
  );

  useEffect(() => {
    if (location.state?.selectedCourseType) {
      setSelectedCourseType(location.state.selectedCourseType);
    }
    if (location.state?.selectedCategoryName) {
      setCategoryId(location.state.selectedCategoryId);
      setCoursesHeading(location.state.selectedCategoryName);
      MixpanelManager.track(MixpanelEvents.courseFilter, {
        category: location.state.selectedCategoryName,
      });
    }
  }, [location.state]);

  const { data: savedData } = useQuery({
    queryKey: ["userSavedCoursesIds"],
    queryFn: () => getSeeCoursesByType({ type: "saved", page: 1 }),
    onSuccess: (res) => {
      const list = res?.data?.data || [];
      if (Array.isArray(list)) {
        try {
          const ids = list.map((c) => Number(c.id)).filter(Boolean);
          const current = new Set(JSON.parse(sessionStorage.getItem("mr_saved_courses") || "[]"));
          ids.forEach((id) => current.add(id));
          sessionStorage.setItem("mr_saved_courses", JSON.stringify(Array.from(current)));
          window.dispatchEvent(new CustomEvent("mrSavedCoursesUpdated"));
        } catch (e) {
          console.error(e);
        }
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });

  const [dynamicSavedIds, setDynamicSavedIds] = useState(() => new Set());

  const savedIdsSet = useMemo(() => {
    const list = savedData?.data?.data || [];
    const set = new Set(list.map((c) => Number(c.id)).filter(Boolean));
    try {
      const stored = JSON.parse(sessionStorage.getItem("mr_saved_courses") || "[]");
      stored.forEach((id) => set.add(Number(id)));
    } catch (e) {}
    dynamicSavedIds.forEach((id) => set.add(Number(id)));
    return set;
  }, [savedData, dynamicSavedIds]);

  const trendingCourses = useMemo(() => {
    const list = data?.home?.trending || [];
    return list.map((c) => ({
      ...c,
      isSave: savedIdsSet.has(Number(c.id)) ? 1 : (c.isSave ?? 0),
    }));
  }, [data?.home?.trending, savedIdsSet]);

  const followingCourses = useMemo(() => {
    const list = data?.home?.following || [];
    return list.map((c) => ({
      ...c,
      isSave: savedIdsSet.has(Number(c.id)) ? 1 : (c.isSave ?? 0),
    }));
  }, [data?.home?.following, savedIdsSet]);

  const recommendedCourses = useMemo(() => {
    const list = data?.home?.recommended?.data || [];
    return list.map((c) => ({
      ...c,
      isSave: savedIdsSet.has(Number(c.id)) ? 1 : (c.isSave ?? 0),
    }));
  }, [data?.home?.recommended?.data, savedIdsSet]);

  const categoryCoursesDecorated = useMemo(() => {
    return categoryCourses.map((c) => ({
      ...c,
      isSave: savedIdsSet.has(Number(c.id)) ? 1 : (c.isSave ?? 0),
    }));
  }, [categoryCourses, savedIdsSet]);

  // Synchronize saved courses count immediately when a course is saved/unsaved
  useEffect(() => {
    const handleSaveToggled = (e) => {
      const isSaved = e.detail?.isSaved;
      const courseId = e.detail?.courseId;
      if (typeof isSaved === "boolean") {
        setCounts((prev) => ({
          ...prev,
          saved: Math.max(0, (prev.saved || 0) + (isSaved ? 1 : -1)),
        }));
        if (courseId) {
          setDynamicSavedIds((prev) => {
            const next = new Set(prev);
            if (isSaved) {
              next.add(Number(courseId));
            } else {
              next.delete(Number(courseId));
            }
            return next;
          });
        }
      }
    };
    window.addEventListener("courseSaveToggled", handleSaveToggled);
    return () => window.removeEventListener("courseSaveToggled", handleSaveToggled);
  }, []);

  const renderCourseTitle = useMemo(() => {
    const courseObj = translatedCourseTypes.find(
      (course_type) => course_type.id === selectedCourseType
    );
    if (!courseObj) return null;
    const courseTitle = courseObj.title;
    if (
      (selectedCourseType === 1 && counts.purchased === 0) ||
      (selectedCourseType === 2 && counts.saved === 0) ||
      (selectedCourseType === 3 && counts.created === 0)
    ) {
      return null;
    }
    return courseTitle.toLowerCase().includes("courses")
      ? courseTitle
      : `${courseTitle} Courses`;
  }, [selectedCourseType, counts, translatedCourseTypes]);

  useEffect(() => {
    MixpanelManager.track(MixpanelEvents.trendingCourses);
    MixpanelManager.track(MixpanelEvents.followingDoctorCourses);
  }, []);

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <NavBar />
      </Row>

      <div className="cr-page-wrapper">
        {/* ================================================================
            DESKTOP TWO-COLUMN EDITORIAL MARKETPLACE
           ================================================================ */}
        <div className="cr-layout feed-aligned-page-layout d-xl-flex d-none">
          {/* Left Sidebar (Hosting Search, Create CTA, Popular/Purchased & Sticky Ad) */}
          <aside className="cr-sidebar">
            <CourseSearchBox />
            <CreateCourseCard />

            {/* Popular / Purchased Courses Component (Scrolls naturally) */}
            <SuggestedCoursesEvents
              tabType="courses"
              purchasedCourses={data?.side?.purchased}
              popularCourses={data?.side?.popular}
              isLoading={adsLoading}
              viewAllPurchased={viewAllPurchased}
              coursePosition=""
            />

            {/* Sticky Advertisement: Sticks at top when scrolled */}
            <div style={{ position: "sticky", top: "5.5rem", zIndex: 5 }}>
              <FeedAdvertisement
                ads={data?.ads?.courses}
                loading={adsLoading}
                new_contest_obj={storedValue}
              />
            </div>
          </aside>

          {/* Right Main Content (Spacious & Editorial) */}
          <main className="cr-main">
            {/* Featured Hero Banner */}
            <CourseBanner banner_images={banner_images} isLoading={isLoading} />

            {/* Course Statistics (Distinct Information Blocks) */}
            <div className="cr-stats-ribbon">
              {translatedCourseTypes.map((course_type) => (
                <CoursesTabMenuCard
                  key={course_type.id}
                  active={course_type.id === selectedCourseType}
                  onClick={() => handleCourseTypeClick(course_type.id)}
                  title={course_type.title}
                  count={counts[course_type.key]}
                  type={course_type.key}
                />
              ))}
            </div>

            {/* Filtered View or Standard Catalog */}
            {selectedCourseType ? (
              <div className="cr-section">
                {renderCourseTitle && (
                  <h2 className="cr-view-title">{renderCourseTitle}</h2>
                )}
                {selectedCourseType === 1 ? (
                  <PurchasedCourses count={counts.purchased} type="purchased" />
                ) : selectedCourseType === 2 ? (
                  <SavedCourses count={counts.saved} type="saved" />
                ) : selectedCourseType === 3 ? (
                  <MyCourses count={counts.created} type="my" />
                ) : null}
              </div>
            ) : (
              <>
                {/* Trending & New Courses */}
                <TrendingCourses courses={trendingCourses} loading={isLoading} />

                {/* Explore Course Categories */}
                <SubcategoryCards
                  categories={data?.home?.subcategories}
                  loading={isLoading}
                  onCategoryDataFetched={handleCategoryData}
                  selectedCatId={categoryId}
                  defaultCoursesData={data?.data}
                />

                {/* Filtered by Category or Following & Recommended */}
                {categoryId ? (
                  <SeeAllCoursesCard
                    heading={coursesHeading}
                    loading={internalLoading || isCategoryLoading}
                    cardData={categoryCoursesDecorated}
                    checkMainPage={true}
                    loadMore={() => !isFetchingNextPage && fetchNextPage()}
                    hasMore={hasNextPage}
                    cardsPerRow={4}
                  />
                ) : (
                  <>
                    <FollowingDoctorCourses
                      followingDoctorCourses={followingCourses}
                      loading={isLoading}
                    />

                    <RecommendedCourses recommendData={recommendedCourses} />
                  </>
                )}
              </>
            )}
          </main>
        </div>

        {/* ================================================================
            MOBILE & TABLET RESPONSIVE LAYOUT
           ================================================================ */}
        <div className="d-xl-none w-100">
          <div className="feed-aligned-page-layout pb-4">
            {/* Mobile Header */}
            <div className="cr-mobile-hdr">
              <h2 className="cr-mobile-hdr-title">Explore Courses Today!</h2>
              <div className="cr-mobile-hdr-actions">
                <div
                  className="cr-mobile-hdr-btn"
                  onClick={handleSearchClick}
                  role="button"
                  tabIndex={0}
                  aria-label="Search courses"
                >
                  <FaSearch size={15} />
                </div>
                <div
                  className="cr-mobile-hdr-btn"
                  onClick={toggle}
                  role="button"
                  tabIndex={0}
                  aria-label="Create course"
                >
                  <FaPlus size={15} />
                </div>
              </div>
            </div>

            {isOpen && <CreateCourseModal isOpen={isOpen} toggle={toggle} />}

            {/* Mobile Hero Banner */}
            <div className="mb-4">
              <CourseBanner banner_images={banner_images} isLoading={isLoading} />
            </div>

            {/* Mobile Course Type Tabs (Horizontally Scrollable) */}
            <div className="cr-type-tabs">
              {translatedCourseTypes.map((course_type) => (
                <button
                  key={course_type.id}
                  className={`cr-type-tab${course_type.id === selectedCourseType ? " active" : ""
                    }`}
                  onClick={() => handleCourseTypeClick(course_type.id)}
                >
                  {course_type.title}
                </button>
              ))}
            </div>

            {/* Mobile Main Content */}
            {selectedCourseType ? (
              <div className="cr-section mb-4">
                {renderCourseTitle && (
                  <h2 className="cr-view-title text-center">{renderCourseTitle}</h2>
                )}
                {selectedCourseType === 1 ? (
                  <PurchasedCourses count={counts.purchased} type="purchased" />
                ) : selectedCourseType === 2 ? (
                  <SavedCourses count={counts.saved} type="saved" />
                ) : selectedCourseType === 3 ? (
                  <MyCourses count={counts.created} type="my" />
                ) : null}
              </div>
            ) : (
              <div className="d-flex flex-column gap-4">
                <TrendingCourses courses={trendingCourses} loading={isLoading} />

                <SubcategoryCards
                  categories={data?.home?.subcategories}
                  loading={isLoading}
                  onCategoryDataFetched={handleCategoryData}
                  selectedCatId={categoryId}
                  defaultCoursesData={data?.data}
                />

                {categoryId ? (
                  <SeeAllCoursesCard
                    heading={coursesHeading}
                    loading={internalLoading || isCategoryLoading}
                    cardData={categoryCoursesDecorated}
                    checkMainPage={true}
                    loadMore={() => !isFetchingNextPage && fetchNextPage()}
                    hasMore={hasNextPage}
                    cardsPerRow={window.innerWidth <= 767 ? 1 : 2}
                  />
                ) : (
                  <>
                    <FollowingDoctorCourses
                      followingDoctorCourses={followingCourses}
                      loading={isLoading}
                    />

                    <RecommendedCourses recommendData={recommendedCourses} />
                  </>
                )}
              </div>
            )}

            {/* Mobile Sidebar Widgets at Bottom */}
            <div className="mt-5 d-flex flex-column gap-4">
              {/* LOCKED: Popular / Purchased Component */}
              <SuggestedCoursesEvents
                tabType="courses"
                purchasedCourses={data?.side?.purchased}
                popularCourses={data?.side?.popular}
                viewAllPurchased={viewAllPurchased}
                coursePosition=""
              />

              {/* LOCKED: Advertisement Component */}
              <FeedAdvertisement
                ads={data?.ads?.courses}
                loading={adsLoading}
                new_contest_obj={storedValue}
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default React.memo(Courses);
